/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useEffect } from "react";

import { dayjsTZ } from "helpers";

const useSyncFormValue = (params: {
  keys: string[];
  config?: {
    dateKeys?: string[];
    autoCompletedKeys?: string[];
  };
  methods: any;
  setField: (e: string, v: any) => void;
}) => {
  const { keys = [], methods, setField, config = {} } = params;
  const { dateKeys = [], autoCompletedKeys = [] } = config;

  useEffect(() => {
    const subscription = methods?.watch((_value: any, { name, type }: any) => {
      if (keys) {
        if (type === "change" && keys?.includes(name as never)) {
          let value = _value?.[name || ""] || undefined;
          if (dateKeys?.includes(name as string)) {
            value = value ? dayjsTZ(value as string).toISOString() : null;
          }
          if (autoCompletedKeys?.includes(name as string)) {
            value = value?.value;
          }
          setField(name as string, value);
        }
      }
    });

    return () => subscription?.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {};
};

export default useSyncFormValue;
